/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type PlanSettingsIssueSourcesType from '@jira/spa-apps__advanced-roadmaps-plan-settings/src/PlanSettingsIssueSources.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import type { Props } from '@jira/portfolio-3__portfolio/src/app-simple-plans/view/settings/work-in-your-plan/types.tsx';

/**
 * Plan Settings - issue-sources page
 */

export const LazyPlanSettingsIssueSources: LazyComponent<
	({ store, ...props }: Props) => React.JSX.Element
> = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
	lazyForPaint<typeof PlanSettingsIssueSourcesType>(
		() =>
			markAsProductBundleReady(
				import(
					/* webpackChunkName: "async-plan-settings-plan-settings-issue-sources", jiraSpaEntry: "async-plan-settings-plan-settings-issue-sources" */ '@jira/spa-apps__advanced-roadmaps-plan-settings/src/PlanSettingsIssueSources.tsx'
				),
			),
		{ ssr: false },
	);

const AsyncPlanSettingsIssueSources = (): React.JSX.Element => (
	<LazyPage
		Page={LazyPlanSettingsIssueSources}
		pageId="plan-settings-issue-sources"
		shouldShowSpinner={false}
	/>
);

export default AsyncPlanSettingsIssueSources;
